import React, { Suspense } from "react";
import LoadingIndicator from "~Image/LoadingIndicator";
export var wrapLazy = function wrapLazy(Component) {
  var Lazy = function Lazy(props) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
    }, /*#__PURE__*/React.createElement(Component, props)));
  };

  Lazy.displayName = 'Lazy';
  return Lazy;
};